import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { FileText, User, Bookmark, FolderOpen } from "lucide-react";
import { cn } from "@/lib/utils";

interface ProfileTabsProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
  children: React.ReactNode;
  className?: string;
  isOwnProfile?: boolean;
}

export function ProfileTabs({ activeTab, onTabChange, children, className, isOwnProfile = false }: ProfileTabsProps) {
  return (
    <Tabs value={activeTab} onValueChange={onTabChange} className={cn("w-full", className)}>
      <TabsList className="w-full sm:w-auto bg-card/50 border border-border/50 p-1 rounded-xl">
        <TabsTrigger
          value="prompts"
          className="flex items-center gap-2 px-4 py-2 rounded-lg data-[state=active]:bg-primary/10 data-[state=active]:text-primary"
        >
          <FileText className="w-4 h-4" />
          <span>Prompts</span>
        </TabsTrigger>
        {isOwnProfile && (
          <TabsTrigger
            value="saved"
            className="flex items-center gap-2 px-4 py-2 rounded-lg data-[state=active]:bg-primary/10 data-[state=active]:text-primary"
          >
            <Bookmark className="w-4 h-4" />
            <span>Saved</span>
          </TabsTrigger>
        )}
        {isOwnProfile && (
          <TabsTrigger
            value="collections"
            className="flex items-center gap-2 px-4 py-2 rounded-lg data-[state=active]:bg-primary/10 data-[state=active]:text-primary"
          >
            <FolderOpen className="w-4 h-4" />
            <span>Collections</span>
          </TabsTrigger>
        )}
        <TabsTrigger
          value="about"
          className="flex items-center gap-2 px-4 py-2 rounded-lg data-[state=active]:bg-primary/10 data-[state=active]:text-primary"
        >
          <User className="w-4 h-4" />
          <span>About</span>
        </TabsTrigger>
      </TabsList>
      {children}
    </Tabs>
  );
}

export function ProfileTabContent({ value, children, className }: {
  value: string;
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <TabsContent value={value} className={cn("mt-6", className)}>
      {children}
    </TabsContent>
  );
}
